import Blank from './Blank';
import schema from './props-schema';

Blank.schema = schema;

// https://github.com/webpack/webpack/issues/706
export default Blank;
